import React from 'react'
import Link from 'gatsby-link'

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

import image1 from '../../layouts/images/auspost/02_Track-User-testing.jpg'
import image2 from '../../layouts/images/auspost/03_co-design workshop agenda.jpg'
import image3 from '../../layouts/images/auspost/01_Track-card sort.jpg'
import image4 from '../../layouts/images/auspost/04_co-design-workshop.jpg'
import image5 from '../../layouts/images/auspost/04.1_co-design-workshop.jpg'
import image6 from '../../layouts/images/auspost/05_co-design-workshop.jpg'
import image7 from '../../layouts/images/auspost/06_Story-board.jpg'
import image8 from '../../layouts/images/auspost/07_runway-elaboration.jpg'
import image9 from '../../layouts/images/auspost/08_Synthesis-process.jpg'
import image10 from '../../layouts/images/auspost/10_Customer journey mapping_PO-Box.jpg'
import image11 from '../../layouts/images/auspost/11_Contextual-Interview-UT.jpg'
import image12 from '../../layouts/images/auspost/14_retro-journey-mapping.jpg'
import image13 from '../../layouts/images/auspost/15_retro-storytelling.jpg'
import image14 from '../../layouts/images/auspost/16_storytelling.jpg'
import image15 from '../../layouts/images/auspost/17_planning-sketches.jpg'
import image16 from '../../layouts/images/auspost/18_success-criteria-workshop.jpg'


const AuspostPage = () => (
    <div className="container">
        <div className="row">
            <div className="col-lg-5 project-info">
                <h3>User Experience research in the postal industry</h3>
                <div className="project-content">

                    <p>During my time at Australia Post I have been the advocate for the end user on the consumer side as well as on the contract business side; and responsible for designing, conducting, analysing and reporting on user-centered design research and usability testing across the following Australia Post digital assets/ experiences: </p>

                    <ul>
                        <li>MyPost</li>
                        <li>Track</li>
                        <li>Delivery Choices and Safe Drop</li>
                        <li>Actionable Notifications</li>
                        <li>Parcel Locker</li>
                        <li>Post Office Box</li>
                        <li>Mail Redirection Service Online & Change of Address Notification</li>
                        <li>Parcel Send - Online Lodgement Tool</li>
                    </ul>
                </div>
            </div>

            <div className="col-lg-7">

                <div className="slider">
                    <ImageGallery
                        showThumbnails={false}
                        showFullscreenButton={false}
                        autoPlay={true}
                        items={[
                            { original: image1, },
                            { original: image2, },
                            { original: image3, },
                            { original: image4, },
                            { original: image5, },
                            { original: image6, },
                            { original: image7, },
                            { original: image8, },
                            { original: image9, },
                            { original: image10, },
                            { original: image11, },
                            { original: image12, },
                            { original: image13, },
                            { original: image14, },
                            { original: image15, },
                            { original: image16, },

                        ]} />
                </div>

                <br />
                <br />

                <p className="project-blurb">User Experience research in the postal industry</p>

                <ul className="tags">
                    <li>Qualitative Interview</li>
                    <li>Participative Observation</li>
                    <li>Ethnographic Listening</li>
                    <li>Face-to-Face User testing</li>
                    <li>Remote Testing and Guerrilla Prototype Testing</li>
                    <li>Card Sorting</li>
                    <li>Treejack testing</li>
                    <li>Diary Study Research</li>
                    <li>Survey</li>
                    <li>Heuristic Evaluation</li>
                    <li>Literature Review</li>
                    <li>Competitive Analysis</li>
                    <li>Co-Design Workshops</li>
                    <li>Success Criteria Workshops</li>
                </ul>

                <div className="footer-info">
                    <p><span className="highlight">Cooperation Partner:</span> Australia Post</p>
                    <p><span className="highlight">Date:</span> 2015 - Present</p>
                </div>

            </div>
        </div>
    </div>
)

export default AuspostPage



// WEBPACK FOOTER //
// ./src/pages/projects/auspost.js